export class PrintService {
  private static instance: PrintService;
  private printServerUrl: string = "http://localhost:5051/api/Printer/print-zpl";

  private constructor() {}

  public static getInstance(): PrintService {
    if (!PrintService.instance) {
      PrintService.instance = new PrintService();
    }
    return PrintService.instance;
  }

  public setPrintServerUrl(url: string): void {
    this.printServerUrl = url;
  }

  public async printZPL(zplContent: string, printerName: string = "zebra"): Promise<void> {
    try {
      const response = await fetch(this.printServerUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          PrinterName: printerName,
          ZplData: zplContent
        })
      });

      if (!response.ok) {
        const errorData = await response.text();
        throw new Error(`Printing error: ${response.status} ${errorData}`);
      }
    } catch (error) {
      console.error('Error sending ZPL to print server:', error);
      throw error;
    }
  }
}

export default PrintService.getInstance();
